export enum InputFieldType {
  Text = 'text',
  Password = 'password',
  Email = 'email',
  Number = 'number',
  Date = 'date',
  Checkbox = 'checkbox',
  Radio = 'radio',
  File = 'file',
  Submit = 'submit'
}

export const PRETTY_INPUT_FIELD_TYPE = {
  [InputFieldType.Text]: 'text',
  [InputFieldType.Password]: 'password',
  [InputFieldType.Email]: 'email',
  [InputFieldType.Number]: 'number',
  [InputFieldType.Date]: 'date',
  [InputFieldType.Checkbox]: 'checkbox',
  [InputFieldType.Radio]: 'radio',
  [InputFieldType.File]: 'file',
  [InputFieldType.Submit]: 'submit'
}
